module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/k3rmiQ/tc-custom/9781398497306.jpg?1705688333532",
      "alt": "This image is the cover for the book The Girl on a Bike"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("The Girl on a Bike\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("A super-rich eminent plastic surgeon, driven insane by grief over the death of his beloved mother who was the light of his life and a celebrity in her own right. Two young, pretty, innocent schoolgirls out riding their bicycles. An FBI criminal profiler assisting a hugely built Chief Superintendent, his handsome young Inspector and attractive female detective constable. These are just some of the characters whose lives become intertwined in this fast-paced, gritty tale of abduction and murder. A gripping and page-turning epic that all tastes will enjoy from beginning to end – oh, and there are five Belgian Blue cats in the mix too. The novel has pathos, humanity and romance and a little comedy as well. It’s a must-read!")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      R.E. Bowden\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("R.E. Bowden is a Senior Lecturer in Visual Communications at Wolverhampton University, now retired. Robert taught students on a BA (Honours) course in Graphic Design. Outside of his career, he is a keen boater and musician, acting as Musical Director for some ten shows and a member of a band. He has written several folk songs about narrow boating on canals and rivers. He is also a keen modeller and enthusiast for the hobby of model railways. He has now written five novels, including a science fiction comedy and a children’s adventure set in Animal World.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0